import { MatPaginatorIntl } from '@angular/material/paginator';
import { LocalizationService } from '../shared/localization/localization.service';

const sloveneRangeLabel = (page: number, pageSize: number, length: number) => {
  if (length === 0 || pageSize === 0) {
    return `0 od ${length}`;
  }

  length = Math.max(length, 0);

  const startIndex = page * pageSize;

  // If the start index exceeds the list length, do not try and fix the end index to the end.
  const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

  return `${startIndex + 1} - ${endIndex} od ${length}`;
};

const defaultRangeLabel = (page: number, pageSize: number, length: number) => {
  if (length === 0 || pageSize === 0) {
    return `0 of ${length}`;
  }

  length = Math.max(length, 0);

  const startIndex = page * pageSize;

  // If the start index exceeds the list length, do not try and fix the end index to the end.
  const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

  return `${startIndex + 1} - ${endIndex} of ${length}`;
};

export function getSlovenePaginatorIntl(localizationService: LocalizationService) {
  const paginatorIntl = new MatPaginatorIntl();

  localizationService.langSubject.subscribe((lang) => {
    if (lang === 'sl') {
      paginatorIntl.itemsPerPageLabel = 'Vrstic na stran:';
      paginatorIntl.nextPageLabel = 'Naslednja stran';
      paginatorIntl.previousPageLabel = 'Prejšnja stran';
      paginatorIntl.getRangeLabel = sloveneRangeLabel;
    } else {
      paginatorIntl.itemsPerPageLabel = 'Items per page:';
      paginatorIntl.nextPageLabel = 'Next page';
      paginatorIntl.previousPageLabel = 'Previous page';
      paginatorIntl.getRangeLabel = defaultRangeLabel;
    }

    paginatorIntl.changes.next();
  });

  return paginatorIntl;
}
